import { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { FaPaperPlane } from "react-icons/fa";

function CustomEditor({ oldData, saveDataHandler, closeEditMode }) {
  const editorRef = useRef(null);
  const editorRef2 = useRef(null);

  const sendDataHandler = () => {
    if (editorRef.current || editorRef2.current) {
      saveDataHandler({
        instruction: editorRef.current.getContent(),
        instructionBn: editorRef2.current.getContent(),
      });
    }
  };

  async function fileUploader(file) {
    const body = new FormData();
    // backdrop
    const backDropDiv = document.querySelector(".tox .tox-dialog");
    backDropDiv.classList.add("loading");
    // disable input
    const textInputArea = document.querySelector(
      ".tox-form__controls-h-stack .tox-control-wrap input.tox-textfield"
    );
    textInputArea.disabled = true;

    body.append("image", file);
    const url = `https://api.imgbb.com/1/upload?key=347525e64775187aed4d03329dbe793a`;
    const data = await fetch(url, {
      method: "POST",
      body: body,
    })
      .then((res) => res.json())
      .then((res) => {
        // return data
        return res.data.url;
      })
      .catch((err) => {
        console.log(err);
      });
    backDropDiv.classList.remove("loading");
    textInputArea.disabled = false;
    return data;
  }

  return (
    <div className="space-y-8 mb-12">
      {/* Instructions */}
      <div>
        <label className="label capitalize block mb-2">
          <span className="text-md font-semibold text-darkPrimary dark:text-darkWhite">
            Instructions
          </span>
          {/* {required && <span className="text-red-500 text-lg">*</span>} */}
        </label>
        <Editor
          apiKey="vwoipfm090lxii0f30df144djin8pzfodjappwdgkq315l9x"
          onInit={(evt, editor) => (editorRef.current = editor)}
          initialValue={oldData.instruction}
          // toolbar="bold italic underline code formatselect image"
          plugins="lists code image wordcount link hr table"
          init={{
            height: 500,
            menubar: false,
            toolbar:
              "undo redo styles | formatselect | " +
              "bold italic hr table link forecolor backcolor image | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat",
            file_picker_types: "image",
            file_picker_callback: (cb, value, meta) => {
              const input = document.createElement("input");
              input.setAttribute("type", "file");
              input.setAttribute("accept", "image/*");

              input.addEventListener("change", (e) => {
                const file = e.target.files[0];

                const reader = new FileReader();
                reader.addEventListener("load", async () => {
                  const uploadedUrl = await fileUploader(file);
                  cb(uploadedUrl, { title: file.name });
                });
                reader.readAsDataURL(file);
              });

              input.click();
            },
            // plugins: [
            //   "advlist autolink lists link image charmap print preview anchor",
            //   "searchreplace visualblocks code fullscreen",
            //   "insertdatetime media table paste code help wordcount",
            // ],
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>
      {/* Instructions bangla */}
      <div>
        <label className="label capitalize block mb-2">
          <span className="text-md font-semibold text-darkPrimary dark:text-darkWhite">
            Instructions - Bangla
          </span>
          {/* {required && <span className="text-red-500 text-lg">*</span>} */}
        </label>
        <Editor
          apiKey="vwoipfm090lxii0f30df144djin8pzfodjappwdgkq315l9x"
          onInit={(evt, editor) => (editorRef2.current = editor)}
          initialValue={oldData.instructionBn}
          // toolbar="bold italic underline code formatselect image"
          plugins="lists code image wordcount link hr table"
          init={{
            height: 500,
            menubar: false,
            toolbar:
              "undo redo styles | formatselect | " +
              "bold italic hr table link forecolor backcolor image | alignleft aligncenter " +
              "alignright alignjustify | bullist numlist outdent indent | " +
              "removeformat",
            file_picker_types: "image",
            file_picker_callback: (cb, value, meta) => {
              const input = document.createElement("input");
              input.setAttribute("type", "file");
              input.setAttribute("accept", "image/*");

              input.addEventListener("change", (e) => {
                const file = e.target.files[0];

                const reader = new FileReader();
                reader.addEventListener("load", async () => {
                  const uploadedUrl = await fileUploader(file);
                  cb(uploadedUrl, { title: file.name });
                });
                reader.readAsDataURL(file);
              });

              input.click();
            },
            // plugins: [
            //   "advlist autolink lists link image charmap print preview anchor",
            //   "searchreplace visualblocks code fullscreen",
            //   "insertdatetime media table paste code help wordcount",
            // ],
            content_style:
              "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          }}
        />
      </div>

      <div className="flex items-center justify-center">
        <button
          onClick={sendDataHandler}
          className="btn btnW7ide font-bold text-white bg-secondary hover:bg-[#025250] hover:shadow-lg px-12 py-3 rounded-lg transition duration-150"
        >
          Submit
          <FaPaperPlane className="inline ml-2.5 mb-0.5 text-sm" />
        </button>
      </div>
    </div>
  );
}

export default CustomEditor;
